import type { IconProps } from "types";

const ChannelCession = ({ color = "#B3B3B3", width= "20px", height = "20px" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4577_24350)">
        <path
          d="M5.00044 2.50049L2.50044 5.00049"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5004 15.0004L15.0004 17.5004"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16711 2.50049L2.50044 9.16715"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3338 2.50049L2.50044 13.3338"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5004 2.50049L2.50044 17.5005"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4996 6.6665L6.66626 17.4998"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4999 10.8335L10.8333 17.5002"
          stroke={color}
          strokeWidth="1.68477"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4577_24350">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ChannelCession;
